import { styled } from "@mui/material/styles";
import {
  Stack,
  useTheme,
  useMediaQuery,
  Typography,
  Box,
  Button,
  Fade,
} from "@mui/material";
import { useShow } from "hooks/useShow";
import Grid from "@mui/material/Unstable_Grid2";
import redstone from "assets/images/home/redstone.png";
import Transitions from "components/Transitions";
// import { Left, Right } from "components/Svg";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

const WapperBox = styled(Stack)`
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {},
  })};
`;

const Head = styled(Typography)`
  color: #fff;
  font-size: 46px;
  font-weight: 500;
  max-width: 500px;
  margin-top: 30px;
  line-height: 1.2;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "24px",
      marginTop: "10px",
    },
  })};
`;

const SubHead = styled(Typography)`
  color: #999;
  font-size: 18px;
  margin-top: 5px;
  font-family: KindSansRegular;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
    },
  })};
`;

const Containter = styled(Stack)`
  height: 100%;
  width: 1200px;
  padding: 15px 25px 150px;
  box-sizing: border-box;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "40px 20px 60px",
    },
  })};
`;

const VideoBox = styled("video")`
  width: 70%;
  height: auto;
  ${({ theme }) => ({
    [theme.breakpoints.down("lg")]: {
      width: "70%",
    },
  })};
`;

const StepBtn = styled(Stack)`
  width: 80px;
  height: 38px;
  border-radius: 40px;
  background: #1a1a1a;
  border: 1px solid #1a1a1a;
  outline: none;
  cursor: pointer;
  .icon {
    color: #999;
    font-size: 16px;
  }
  &:hover {
    border: 1px solid #3f3f3f;
    background: #1a1a1a;
    .icon {
      color: #fff;
    }
  }
`;

const VertTabs = styled(Tabs)`
  width: 1px;
  background: #3f3f3f;
  .MuiTabs-indicator {
    background-color: #fff;
  }
`;
const VertTab = styled(Tab)`
  height: 80px;
`;

const RowTabs = styled(Tabs)`
  width: 100%;
  height: 1px;
  background: #3f3f3f;
  min-height: 1px;
  .MuiTabs-indicator {
    background-color: #fff;
  }
`;
const RowTab = styled(Tab)`
  flex: 1;
  height: 1px;
  min-height: 1px;
`;

const IntItem = styled(Stack)`
  /* height: 80px; */
`;
const Info = styled(Typography)`
  color: #999;
  font-size: 16px;
  font-family: KindSansRegular;
  &.active {
    color: #fff;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("lg")]: {
      fontSize: "14px",
    },
  })};
`;

const Introduction = () => {
  const theme = useTheme();
  const downToMd = useMediaQuery(theme.breakpoints.down("md"));
  const { ref, isShow } = useShow();
  const [value, setValue] = useState(0);
  const videoRef = useRef<HTMLVideoElement>(null);
  const intList = [
    "USD0x is a T-bill-backed, interoperable stablecoin powered by Stables Labs.",
    "USD0x aggregates various US Treasury Bill tokens, bringing,TradFi-level stability to the decentralized world. ",
    "USD0x is the 1st mirrorable T-bills backed stablecoin CEXs will recognize, going beyond normal boundaries of a stablecoin to become the building block of new financial system.",
    "USD0x is fully transferable and permissionless, ensuring seamless integration and accessibility within the DeFi ecosystem.",
  ];
  const onStep = (value: number, type: string) => {
    let num = value;
    if (type === "next") {
      if (value === 3) {
        num = 0;
      } else {
        num = value + 1;
      }
    } else {
      if (value === 0) {
        num = 3;
      } else {
        num = value - 1;
      }
    }
    setValue(num);
    // if (videoRef.current) {
    //   videoRef.current.playbackRate = 3;
    //   videoRef.current.play();
    // }
  };

  useEffect(() => {
    if (videoRef.current && videoRef.current.play) {
      videoRef.current.playbackRate = 3;
      videoRef.current
        ?.play()
        .catch((error) => console.log("播放失败:", error));
    }
  }, [value, videoRef]);

  // useEffect(() => {
  //   if (videoRef.current) {
  //     videoRef.current.play();
  //   }
  // }, [videoRef]);

  useEffect(() => {
    let interval = setInterval(() => {
      if (value === 3) {
        setValue(0);
      } else {
        setValue((prev) => prev + 1);
      }
    }, 4000);
    return () => clearInterval(interval);
  }, [value]);

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  return (
    <WapperBox justifyContent="center" alignItems="center" direction="row">
      <Containter>
        <Stack>
          <Transitions delay={200} isShow={isShow}>
            <SubHead>Introduction</SubHead>
          </Transitions>
          <Transitions delay={400} isShow={isShow}>
            <Head>USD0x, a T-bill-bakced Stablecoin</Head>
          </Transitions>
        </Stack>
        <Grid
          justifyContent={downToMd ? "center" : "space-between"}
          alignItems={downToMd ? "center" : "center"}
          direction={downToMd ? "column" : "row"}
          container
          spacing={10}
          mt={{ xs: 5, md: 50 }}
        >
          <Grid xs={12} md={6}>
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              direction={"row"}
              height={"100%"}
            >
              <Box>
                <Stack
                  justifyContent={"center"}
                  alignItems="center"
                  direction="row"
                >
                  <VideoBox
                    playsInline
                    webkit-playsinline="true"
                    disablePictureInPicture
                    muted
                    controls={false}
                    ref={videoRef}
                  >
                    <source src={`/images/introduction.mp4`} type="video/mp4" />
                  </VideoBox>
                </Stack>
                <Stack
                  justifyContent={"center"}
                  alignItems="center"
                  direction="row"
                  mt={15}
                >
                  <StepBtn
                    justifyContent={"center"}
                    alignItems="center"
                    direction="row"
                    onClick={() => {
                      onStep(value, "pre");
                    }}
                  >
                    <ArrowBackIosIcon className="icon left" />
                  </StepBtn>
                  <Box ml={15}>
                    <StepBtn
                      justifyContent={"center"}
                      alignItems="center"
                      direction="row"
                      onClick={() => {
                        onStep(value, "next");
                      }}
                    >
                      <ArrowForwardIosIcon className="icon left" />
                    </StepBtn>
                  </Box>
                </Stack>
              </Box>
            </Stack>
          </Grid>
          <Grid ref={ref} xs={12} md={6}>
            {downToMd && (
              <Stack mt={20}>
                <RowTabs value={value}>
                  {intList.map(() => {
                    return <RowTab />;
                  })}
                </RowTabs>
                <Box mt={20}>
                  {intList.map((item, index) => {
                    return (
                      <Fade in={value === index} timeout={200}>
                        <Box>
                          <TabPanel value={value} index={index}>
                            <Info
                              style={{
                                color: value === index ? "#fff" : "#999",
                              }}
                            >
                              {item}
                            </Info>
                          </TabPanel>
                        </Box>
                      </Fade>
                    );
                  })}
                </Box>
              </Stack>
            )}
            {!downToMd && (
              <Stack
                justifyContent={"flex-start"}
                alignItems={"center"}
                direction={"row"}
              >
                <VertTabs orientation="vertical" value={value}>
                  {intList.map(() => {
                    return <VertTab />;
                  })}
                </VertTabs>
                <Stack
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  direction={"column"}
                  pl={40}
                  height={320}
                >
                  {intList.map((item, index) => {
                    return (
                      <IntItem key={index}>
                        <Transitions delay={400 + 100 * index} isShow={isShow}>
                          <Info
                            style={{
                              color: value === index ? "#fff" : "#999",
                            }}
                          >
                            {item}
                          </Info>
                        </Transitions>
                      </IntItem>
                    );
                  })}
                </Stack>
              </Stack>
            )}
          </Grid>
        </Grid>
      </Containter>
    </WapperBox>
  );
};

export default Introduction;
